import ugcList from '@/pages/ugc/list'
import ugcDetail from '@/pages/ugc/detail'
import ugcCreate from '@/pages/ugc/create'
import ugcIntro from '@/pages/ugc/intro'
import uploadterms from '@/pages/ugc/uploadterms'
const ugc_router = [
  {
    path: '/scene/list',
    component: ugcList,
    meta: {
      title: '夜计划现场',
      auth: false,
      jicePageTitle: '照片墙一览页',
    },
  },
  {
    path: '/scene/detail/:id',
    component: ugcDetail,
    meta: {
      title: '详情',
      auth: false,
    },
  },
  {
    path: '/scene/create',
    component: ugcCreate,
    meta: {
      title: '发布夜计划',
      auth: true,
    },
  },
  {
    path: '/scene/intro',
    component: ugcIntro,
    meta: {
      title: '发布夜计划',
      auth: false,
    },
  },
  {
    path: '/scene/uploadterms',
    component: uploadterms,
    meta: {
      title: '上传须知',
      auth: false,
    },
  },
]
export default ugc_router



// WEBPACK FOOTER //
// ./src/router/ugc.js